module.exports = __webpack_public_path__ + "img/couture-depiquee.8147707f.svg";